import { render, staticRenderFns } from "./NavSections.vue?vue&type=template&id=952ec27c&"
import script from "./NavSections.vue?vue&type=script&lang=js&"
export * from "./NavSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports